interface ToggleProps {
    value: boolean;
    onChange: (next: boolean) => void;
    label: string;
}

export default function Toggle({ value, onChange, label }: ToggleProps) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={value}
            aria-label={label}
            onClick={() => onChange(!value)}
            className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full transition-colors ${value ? 'bg-[#6e64f0]' : 'bg-[#cbd5e1]'}`}
        >
            <span
                className={`pointer-events-none absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform ${value ? 'translate-x-5' : 'translate-x-0'}`}
            />
        </button>
    );
}
